import * as React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import { TableHead, TextField, Chip, Checkbox } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useGetUsersQuery } from '../../../features/users/usersApiSlice';
import { memo } from 'react';
import PulseLoader from 'react-spinners/PulseLoader';
import { useLocation, Navigate, Outlet } from "react-router-dom";
import nameStringFn from "../../../data/nameStringFn";
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import {TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import { useGetdesignationsQuery } from '../../../features/designations/designationApiSlice';
import DetailsIcon from '@mui/icons-material/Details';
// import UserdetailsModal from './UserdetailsModal';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import useAuth from '../../../features/hooks/useAuth';
import styled from 'styled-components';
import { useGetAssetsFinalQuery } from '../../../features/addassets/addassetfinalApiSlice';
import UnivMyConsumables from './UnivMyConsumables';
import { useSelector } from 'react-redux';
import { useGetconsumablesQuery } from '../../../features/consumable/consumableApiSlice';



const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Button2Div =styled.div`
  display: flex;
  justify-content: end;

`
const Wrapper = styled.div`
    display: flex;
    background-color: white;
    align-items:center;
    /* width: 100; */
`

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function CustomPaginationActionsTable() {
  const Auth = useAuth();
  const [tabledata, setTabledata]= useState([]);  

  let user_current_office = (useSelector((state) => state.office.off));

  const {users} =  useGetUsersQuery("UserList", {
    selectFromResult: ({ data }) => ({
      users: data?.entities
    }),
  })
  //get single assets
  const { getSingleasset } = useGetAssetsFinalQuery('allassetlist', {
    selectFromResult: ({ data }) => ({
      getSingleasset: data?.entities
    }),
  });

  const {consumables} = useGetconsumablesQuery('allconsumables', {
    selectFromResult: ({ data }) => ({
      consumables: data?.entities
    }),
  })

useEffect(()=>{
  if(getSingleasset && users && consumables){
    let consumableArray = structuredClone(Object.values(consumables)?.filter( x => x.status === "approved"));
    let finalArray = []
    if(Object.values(Auth.roles).flat(3)?.includes("Admin")){
      console.log("Entered Admin")
      finalArray = [...consumableArray];
      setTabledata(finalArray)
      return
    } 
    //Check Here
    console.log(user_current_office);
    console.log(Auth.id)
    finalArray = consumableArray.filter( x => (x.alloc_user === Auth.id) && (x.alloc_ofc === user_current_office) )
    console.log(finalArray)

    if(Object.values(Auth.roles).flat(3)?.includes("level1approver") || Object.values(Auth.roles).flat(3)?.includes("level2approver") || Object.values(Auth.roles).flat(3)?.includes("assetadder")){
      console.log("Entered Level1approver")
      let storeOffices = [];
      for(let key in Auth.roles){
        if (Auth.roles[key].includes("level1approver") || Auth.roles[key].includes("level2approver") || Auth.roles[key].includes("assetadder") ){
          storeOffices.push(key);
        }
      }
      finalArray = finalArray.concat(consumableArray.filter(x => storeOffices.includes(x.cur_store) || storeOffices.includes(x.pur_store)))
    }
    if(Object.values(Auth.roles).flat(3)?.includes("Bo") || Object.values(Auth.roles).flat(3)?.includes("UnitHead")){
      console.log("Entered Bo or UnitHead")
      let uhOffices = []
      for(let key in Auth.roles){
        if (Auth.roles[key].includes("Bo") || Auth.roles[key].includes("UnitHead")){
          uhOffices.push(key);
        }
      }
      //Check for duplicate object entries
      consumableArray.filter(x => uhOffices.includes(x.alloc_ofc)).forEach(obj => {
        //Check if the object exists in the array
        if(!finalArray.some(item => item._id === obj._id)){
          finalArray.push(obj);
        }
      }
      )
    }
    //Checking for duplicate Object Entries
    consumableArray.filter(x => Object.values(Auth.id) === x?.alloc_user).forEach(obj => {
    //Check if the object exists in the array
    if(!finalArray.some(item => item._id === obj._id)){
          finalArray.push(obj);
        }
      }
    )
    // if(Auth.roles){
    //   finalArray = assetArray.filter( x => (x.alloc_user === Auth.id) && (x.alloc_ofc === user_current_office) )
    // }
    setTabledata(finalArray)
  }
},[getSingleasset,users,user_current_office])


console.log(tabledata)
console.log(Object.values(Auth.roles))

// Other Arguments to be passed as props
const keyArrayDwld = ["orderno","category","consumable", "order_quantity","pur_store", "cur_store", "unit_price", "oem","partno","vendor", "alloc_ofc","purchase_date", "warrantyexp_date", "installation_date", "ledge_ref", "bill_ref", "remarks", "last_trans_date", "final_trasac", "intransit_transac", "addstatus"]
const columnFilter = [ "OrderNo", "Category","Consumable",  "PartNo",  "Store", "OrderQty", "BalanceQty", "TransitQty", "Purchase Date", "Detail"]
return (
    <>    
      <HeadingWrap>
        <Span>Consumables Detail</Span>
      </HeadingWrap>
      <UnivMyConsumables keyArrayDwld = {keyArrayDwld} finalData = {tabledata} columnFilter = {columnFilter} />
    </>
  );
}